export const formPlaceHolders = {
  login: {
    primaryId: 'primary',
    primaryLabel: 'Email Address',
    primaryType: 'email',
    isPrimaryRequired: true,
    primaryAutoCompleteText: 'email',
    secondaryId: 'secondary',
    secondaryLabel: 'Password',
    secondaryType: 'password',
    isSecondaryRequired: true,
    secondaryAutoCompleteText: 'current-password',
    submitText: 'Sign in',
  },

  country: {
    title: '',
    hasDropdown: true,
    dropDownTitle: 'Select Country',
    dropDownOnly: true
  },

  chooseCity: {
    title: '',
    submitText: 'View Areas',
    hasDropdown: true,
    dropDownTitle: 'Cities',
    dropDownOnly: true
  },

  addArea: {
    title: 'Area',
    primaryLangDepId: 'primaryLangDep',
    primaryLangDepLabel: 'Name',
    primaryLangDepType: 'text',
    isPrimaryLangDepRequired: true,
    primaryLangDepAutoCompleteText: '',
    secondaryLangDepId: 'secondaryLangDep',
    primaryId: 'primary',
    primaryLabel: 'Latitude',
    primaryType: 'number',
    isPrimaryRequired: true,
    primaryAutoCompleteText: '',
    secondaryId: 'secondary',
    secondaryLabel: 'Longitude',
    secondaryType: 'number',
    isSecondaryRequired: true,
    tertiaryId: 'tertiary',
    tertiaryLabel: 'Display Order',
    tertiaryType: 'number',
    isTertiaryRequired: true,
    submitText: 'Save',
    hasDropdown: true,
    dropDownTitle: 'Cities',
    dropDownId: 'primaryDd',
    secondaryDropDownTitle: 'Category Id',
    secondaryDropDownId: 'secondaryDd',
    multiTapData: true
  },

  cities: {
    title: 'City',
    primaryLangDepId: 'primaryLangDep',
    primaryLangDepLabel: 'Name',
    primaryLangDepType: 'text',
    isPrimaryLangDepRequired: true,
    primaryLangDepAutoCompleteText: '',
    primaryId: 'primary',
    primaryLabel: 'Display Order',
    primaryType: 'number',
    isPrimaryRequired: true,
    submitText: 'Save',
    hasDropdown: false,
    multiTapData: true,
    checkboxItems: [{
      label: "Is Default",
      id: "primaryChk"
    }]
  },

  insurances: {
    title: 'Insurance',
    primaryLangDepId: 'primaryLangDep',
    primaryLangDepLabel: 'Name',
    primaryLangDepType: 'text',
    isPrimaryLangDepRequired: true,
    primaryLangDepAutoCompleteText: '',
    primaryId: 'primary',
    primaryLabel: 'Display Order',
    primaryType: 'number',
    isPrimaryRequired: true,
    submitText: 'Save',
    hasDropdown: false,
    multiTapData: true
  },

  "main specialities": {
    title: 'Main Specialty',
    primaryLangDepId: 'primaryLangDep',
    primaryLangDepLabel: 'Name',
    primaryLangDepType: 'text',
    isPrimaryLangDepRequired: true,
    primaryLangDepAutoCompleteText: '',
    secondaryLangDepLabel: 'Friendly Name',
    secondaryLangDepType: 'text',
    isSecondaryLangDepRequired: false,
    secondaryLangDepAutoCompleteText: '',
    tertiaryLangDepId: 'tertiaryLangDep',
    tertiaryLangDepLabel: 'Preferred Name',
    tertiaryLangDepType: 'text',
    isTertiaryLangDepRequired: false,
    tertiaryLangDepAutoCompleteText: '',
    quaternaryLangDepId: 'quaternaryLangDep',
    quaternaryLangDepLabel: 'Title Display Name',
    quaternaryLangDepType: 'text',
    isQuaternaryLangDepRequired: false,
    quaternaryLangDepAutoCompleteText: '',
    quinaryLangDepId: 'quinaryLangDep',
    quinaryLangDepLabel: 'Description',
    quinaryLangDepType: 'text',
    isQuinaryLangDepRequired: false,
    quinaryLangDepAutoCompleteText: '',
    primaryId: 'primary',
    primaryLabel: 'Display Order',
    primaryType: 'number',
    isPrimaryRequired: true,
    submitText: 'Save',
    hasDropdown: false,
    secondaryDropDownTitle: 'Related Speciality',
    secondaryDropDownId: 'secondaryDd',
    multiTapData: true,
  },

  "sub specialities": {
    title: 'Sub Specialty',
    primaryLangDepId: 'primaryLangDep',
    primaryLangDepLabel: 'Name',
    primaryLangDepType: 'text',
    isPrimaryLangDepRequired: true,
    primaryLangDepAutoCompleteText: '',
    secondaryLangDepLabel: 'Friendly Name',
    secondaryLangDepType: 'text',
    isSecondaryLangDepRequired: false,
    secondaryLangDepAutoCompleteText: '',
    tertiaryLangDepId: 'tertiaryLangDep',
    tertiaryLangDepLabel: 'Preferred Name',
    tertiaryLangDepType: 'text',
    isTertiaryLangDepRequired: false,
    tertiaryLangDepAutoCompleteText: '',
    quaternaryLangDepId: 'quaternaryLangDep',
    quaternaryLangDepLabel: 'Title Display Name',
    quaternaryLangDepType: 'text',
    isQuaternaryLangDepRequired: false,
    quaternaryLangDepAutoCompleteText: '',
    quinaryLangDepId: 'quinaryLangDep',
    quinaryLangDepLabel: 'Description',
    quinaryLangDepType: 'text',
    isQuinaryLangDepRequired: false,
    quinaryLangDepAutoCompleteText: '',
    primaryId: 'primary',
    primaryLabel: 'Display Order',
    primaryType: 'number',
    isPrimaryRequired: true,
    submitText: 'Save',
    hasDropdown: false,
    secondaryDropDownTitle: 'Related Speciality',
    secondaryDropDownId: 'secondaryDd',
    tertiaryDropDownTitle: 'Parent Speciality',
    tertiaryDropDownId: 'tertiaryDd',
    multiTapData: true,
  },

  areas: {
    title: 'Area',
    primaryLangDepId: 'primaryLangDep',
    primaryLangDepLabel: 'First Language Name',
    primaryLangDepType: 'text',
    isPrimaryLangDepRequired: true,
    primaryLangDepAutoCompleteText: '',
    primaryId: 'primary',
    primaryLabel: 'Second Language Name',
    primaryType: 'text',
    isPrimaryRequired: true,
    primaryAutoCompleteText: '',
    submitText: 'Save',
    hasDropdown: false,
  },
  chooseCityAndArea : {
      secondaryDropDownTitle: 'City',
      secondaryDropDownId: 'secondaryDd',
      tertiaryDropDownTitle: 'Area',
      tertiaryDropDownId: 'tertiaryDd',
      submitText: 'View Neighbours',
  },
  addAreaNeighbour : {
    title : 'Add Area Neighbour',
    secondaryDropDownTitle: 'Child City',
    secondaryDropDownId: 'secondaryDd',
    tertiaryDropDownTitle: 'Child Area',
    tertiaryDropDownId: 'tertiaryDd',
    primaryId: 'primary',
    primaryLabel: 'Neighbouring Order',
    primaryType: 'number',
    isPrimaryRequired: true,
    helperText : 'To ',
    submitText: 'Add Neighbour',
}

  // reference: {
  //   title: 'reference',
  //   primaryLangDepId :'primaryLangDep',
  //   primaryLangDepLabel: 'reference',
  //   primaryLangDepType: 'reference',
  //   isPrimaryLangDepRequired: true,
  //   primaryLangDepAutoCompleteText: 'reference',
  //   primaryLabel: 'reference',
  //   primaryType: 'reference',
  //   isPrimaryRequired: true,
  //   primaryAutoCompleteText: 'reference',
  //   tertiaryLabel: 'reference',
  //   tertiaryType: 'reference',
  //   isTertiaryRequired: true,
  //   tertiaryAutoCompleteText: '',
  //   submitText: 'reference',
  //   hasDropdown: true,
  //   dropDownTitle: 'reference'
  //   dropdownOnly : true
  //   multiTapData : true
  // }
}